import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row
} from "reactstrap"
import * as Yup from "yup"

import Breadcrumbs from "components/Common/Breadcrumb"
import CommonDialog from "components/Common/CommonDialog"

import { addSMSTemplate, editSMSTemplate, getTemplateSMS } from "../../helpers/UAM/sms.helper";
import { SystemConfigurationContext } from "context/systemConfigContext"
// import { useToast } from "ToastStore"

const AddSMSTemplate = props => {
  const navigate = useNavigate()
  const location = useLocation()
  const pathnameSegments = location.pathname.split("/")
  const { roleName } = JSON.parse(localStorage.getItem("user"))
  const lastSegment = pathnameSegments[pathnameSegments.length - 1]
  //meta title
  let formattedLastSegment = lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1).toLowerCase();
  document.title = `${formattedLastSegment} Template | DMS`
  const urlParams = new URLSearchParams(window.location.search)
  const encodedId = urlParams.get("id")
  const decodedId = atob(encodedId)
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [templateList, setTemplateList] = useState({})
  const [showViewTemplate, setShowViewTemplate] = useState(false);
  const [showEditTemplate, setShowEditTemplate] = useState(true);
  const {inputMax} = useContext(SystemConfigurationContext)

  // const { handleToastData } = useToast();

  useEffect(() => {
    if (lastSegment == "edit" || lastSegment == "view") {
      getTemplateSMS({ templateId: decodedId })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 200) {
            setTemplateList(responseFromAPI.data)
            const initialContent = responseFromAPI.data.smsBody;
            const blocksFromHTML = convertFromHTML(initialContent);
            const initialEditorState = EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHTML));
            setEditorState(initialEditorState);
          }
        })
        .catch(error => { })
    }

    if (lastSegment == "view") {
      setShowViewTemplate(true)
      setShowEditTemplate(false)
    } else {
      setShowViewTemplate(false)
      setShowEditTemplate(true)
    }
  }, [])

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      smsType: templateList.smsType || "",
      description: templateList.description || "",
      smsBody: templateList.smsBody || "",
    },
    validationSchema: Yup.object({
      smsType: Yup.string().required("Please Enter SMS Type"),
      description: Yup.string().required("Please Enter SMS Description"),
      smsBody: Yup.string().required("Please Enter SMS Body")
    }),
    onSubmit: values => {
      const message = lastSegment == 'edit' ? 'Are you sure want to update SMS template?' : 'Do you want to save entry?'
      setShowCommonDialog({ isShow: true, message: message })
    },
  })

  const navigateBack = () => {
    const encryptedtemplate = btoa("sms");
    navigate(`/${roleName}/email-template?temp=${encryptedtemplate}`)
  }


  const submiTemplates = () => {
    const { values } = validation
    if (lastSegment == "edit") {
      const updateTemplate = {
        templateId: decodedId,
        smsType: values.smsType,
        description: values.description,
        smsBody: values.smsBody
      }
      editSMSTemplate(updateTemplate)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            const encryptedtemplate = btoa("sms");
            // handleToastData(responseFromAPI.message, "warning")
            navigate(`/${roleName}/email-template?temp=${encryptedtemplate}`);
          }
        })
        .catch(error => { })
      validation.resetForm()
    } else {
      const newTemplate = {
        smsType: values.smsType,
        description: values.description,
        smsBody: values.smsBody
      }
      addSMSTemplate(newTemplate)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            const encryptedtemplate = btoa("sms");
            // handleToastData(responseFromAPI.message, "success")
            navigate(`/${roleName}/email-template?temp=${encryptedtemplate}`);
          }
        })
        .catch(error => { })
      validation.resetForm()
    }
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      submiTemplates()

    } else {

      setShowCommonDialog({ isShow: false })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Template"
            breadcrumbItem={`${lastSegment.toUpperCase()} Template`}
          />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  {showEditTemplate && <form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row className="mb-4">
                      <Col sm={6} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label required"
                        >
                          Type
                        </Label>
                        <Input
                          maxLength={inputMax}
                          type="text"
                          className="form-control"
                          name="smsType"
                          id="horizontal-sms-Input"
                          placeholder="Enter SMS Type"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.smsType || ""}
                          invalid={
                            validation.touched.smsType &&
                            validation.errors.smsType
                          }
                        />
                        {validation.touched.smsType &&
                          validation.errors.smsType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.smsType}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-sms-Input"
                          className="col-sm-3 col-form-label required"
                        >
                          Description
                        </Label>
                        <Input
                          maxLength={inputMax}
                          type="text"
                          className="form-control"
                          name="description"
                          id="horizontal-email-Input"
                          placeholder="Enter SMS Description "
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description || ""}
                          invalid={
                            validation.touched.description &&
                            validation.errors.description
                          }
                        />
                        {validation.touched.description &&
                          validation.errors.description ? (
                          <FormFeedback type="invalid">
                            {validation.errors.description}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label required"
                        >
                          SMS Body
                        </Label>
                        <Input
                          maxLength={inputMax}
                          type="textarea"
                          className="form-control"
                          name="smsBody"
                          style={{ height: "200px" }}
                          id="horizontal-sms-Input"
                          placeholder="Enter SMS Body"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.smsBody || ""}
                          invalid={
                            validation.touched.smsBody &&
                            validation.errors.smsBody
                          }
                        />
                        {validation.touched.smsBody &&
                          validation.errors.smsBody ? (
                          <FormFeedback type="invalid">
                            {validation.errors.smsBody}
                          </FormFeedback>
                        ) : null}
                      </Col>


                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end" style={{ margin: "20px 0% 0px 0px" }}>
                          <button
                            type="submit"
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              navigateBack();
                            }
                            }
                          >
                            Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success save-customer"
                            style={{ marginLeft: "7px" }}
                          >
                            Save
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </form>}
                  {showViewTemplate && <div>
                    <Row className="mb-4">
                      <Col sm={6}>
                        <Label
                          className="col-sm-3 col-form-label label label-styling "
                        >
                          Type
                        </Label>
                        <p>{templateList.smsType || "-"}</p>
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label label label-styling "
                        >
                          Description
                        </Label>
                        <p>{templateList.description || "-"}</p>
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={12}>
                        <Label
                          className="col-sm-3 col-form-label label label-styling "
                        >
                          SMS Body
                        </Label>
                        <p>{templateList.smsBody || "-"}</p>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div className="text-end" >
                          <button
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              navigateBack()
                            }}
                          >
                            Back
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>}

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog &&
        <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
      }
    </React.Fragment>
  )
}

AddSMSTemplate.propTypes = {
  history: PropTypes.object,
}

export default AddSMSTemplate
